import { useEffect } from "react";

import { useThunkDispatch } from "@/redux/dispatcher";
import { CartItemModel } from "@/redux/modules/api/data/cart/@types/cart.model";
import { CTAAction } from "@/redux/modules/api/data/cart/@types/cart.types";
import * as CartModule from "@/redux/modules/api/data/cart/cart.module";
import { useCallToActionsContext } from "@/utils/callToActions/callToActions.provider";

type Props = {
    product: CartItemModel | null;
};

const RemoveArticleAction = ({ product }: Props) => {
    const dispatch = useThunkDispatch();
    const { closeDialog, setLoading } = useCallToActionsContext();

    // biome-ignore lint/correctness/useExhaustiveDependencies: <TODO>
    useEffect(() => {
        if (product) {
            setLoading(true);
            dispatch(
                product.free && !product.freeEntryAddedByCustomer
                    ? CartModule.removeFreeArticleFromCart(product.id!, product)
                    : CartModule.removeFromCart(
                          product.id!,
                          product.quantity,
                          product.free
                      )
            ).then((action) => {
                if (action.type === CartModule.APIStatus.SUCCESS) {
                    closeDialog();
                }
            });
        }
    }, []);

    return null;
};

const RemoveArticle: CTAAction = (product: CartItemModel | null) => (
    <RemoveArticleAction product={product} />
);

export default RemoveArticle;
